export default __webpack_public_path__ + "static/media/nest_black.2d5c8afe.png";